const Spinner = () => {
  return (
    <div className="flex justify-center items-center mt-32">
      <div className="spinner w-8 h-8 border-4 border-blue-500 border-dashed rounded-full"></div>
    </div>
  );
};

export default Spinner;
